import { Button, Form, Modal, Space } from "antd"
import { useTranslation } from "react-i18next"

import type { DecisionFormData } from "../api/services.type.ts"
import type { AccountDeletionRequest } from "../types/types.ts"
import { TextArea } from "../../../components/Input/TextArea.tsx"

interface DecisionModalProps {
  open: boolean
  mode: "approve" | "reject"
  request: AccountDeletionRequest
  loading: boolean
  onCancel: () => void
  onSubmit: (data: DecisionFormData) => void
}

export const DecisionModal = ({
  open,
  mode,
  request,
  loading,
  onCancel,
  onSubmit
}: DecisionModalProps) => {
  const { t } = useTranslation()
  const [form] = Form.useForm<DecisionFormData>()

  const title =
    mode === "approve"
      ? t("accountDeletionRequests.actions.confirmApprove")
      : t("accountDeletionRequests.actions.confirmReject")

  return (
    <Modal
      open={open}
      title={title}
      footer={null}
      onCancel={onCancel}
      destroyOnClose
    >
      <p>
        {request.user.name} — {request.user.email}
      </p>
      <Form form={form} layout="vertical" disabled={loading} onFinish={onSubmit}>
        <Form.Item
          name="admin_comment"
          label={t("accountDeletionRequests.actions.comment")}
        >
          <TextArea rows={4} />
        </Form.Item>
        <Space>
          <Button onClick={onCancel}>
            {t("accountDeletionRequests.actions.cancel")}
          </Button>
          <Button
            type="primary"
            danger={mode === "reject"}
            htmlType="submit"
            loading={loading}
          >
            {mode === "approve"
              ? t("accountDeletionRequests.actions.approve")
              : t("accountDeletionRequests.actions.reject")}
          </Button>
        </Space>
      </Form>
    </Modal>
  )
}
